module.exports = __webpack_public_path__ + "img/farzana-christopher-132.bf612d49.jpg";